export const sectionTemplateMapDetails = (sectionTemplate) => {
    return {
        sectionType: sectionTemplate.sectionType,
        displayName: sectionTemplate.displayName,
        sectionDataTableType: sectionTemplate.sectionDataTableType,
        reportDisplayName: sectionTemplate.reportDisplayName
    }
}